<template>
    <el-card class="box-card"
  style="width: 1300px;margin:80px auto 0;"
  >
    <el-table
      :data="tableData"
      >
    
      <el-table-column
        prop="title"
        label="主题"
        >
      </el-table-column>
      <el-table-column
        prop="cot"
        label="答题次数">
      </el-table-column>
       <el-table-column
        prop="zscore"
        label="总分">
      </el-table-column>
        <el-table-column
        prop="inserttime"
        label="创建日期"
        >
      </el-table-column>
      <el-table-column>
             <template slot-scope="scope">
                       <el-button v-if="scope.row.cot!==1" type="primary" @click.native="goAnswer(scope.$index,tableData)">答题</el-button>
                        <el-button v-if="scope.row.cot!==0" type="success" plain @click.native="goScore(scope.$index,tableData)">查看得分详情</el-button>
             </template>
      </el-table-column>
    </el-table>
    </el-card>
</template>

  <script>

    export default {
      data() {
        return {
          tableData:[],
          keys:"",
          
        }
      },
      methods:{
         

         init(){
                   this.$http.post("Exam/GetSearchList", {
                            keys: this.keys,
                            pageIndex: 1,
                            pageSize: 20,
                            action:"getuserexam",
                            //   action: "getexamxq",
                            
                            })
                            .then((res) => {
                                if(res.data.isok){
                                    this.tableData = res.data.data
                                }
                            })
         },
         goAnswer(index,tableData){
              this.$router.push({path:'/answer',query:{id:tableData[index].examid}})
         },
         goScore(index,tableData){
           this.$router.push({path:'/queryscore',query:{id:this.tableData[index].examid}})
         }

     

      },
      created(){
         this.init()
      }
    }

    
  </script>


// WEBPACK FOOTER //
// src/components/Online.vue